require.config({
    config: {
        // explicitly set locale
        i18n: {
            locale: 'en'
        }
    },
    waitSeconds: 60,
    paths: {
        'd3': 'libs/vendor/d3/d3.min',
        'moment': 'libs/vendor/moment/moment',
        'webfont': 'libs/vendor/webfontloader-min/webfont',
        'closure-templates': 'libs/vendor/closure-templates/soyutils',
        'backbone': 'libs/vendor/backbone/backbone',
        'backbone.queryparams': 'libs/vendor/backbone-query-parameters/backbone.queryparams',
        'underscore': 'libs/vendor/lodash/lodash',
        'modernizr': 'libs/vendor/modernizr/modernizr',
        'bootstrap': 'libs/vendor/bootstrap-sass-official/assets/javascripts/bootstrap',
        'jquery': 'libs/vendor/jquery/jquery.min',
        'jquery-ui': 'libs/vendor/jquery-ui/ui',
        'jquery.sly': 'libs/vendor/sly/dist/sly',
        'jquery.mobile' : 'lib/jquery.mobile.custom.min',
        'select2v4': 'libs/vendor/select2/dist/js/select2.full',
        'perfect-scrollbar.jquery' : 'libs/vendor/perfect-scrollbar/js/perfect-scrollbar.jquery'
    },
    shim: {
        'backbone': {
            exports: 'Backbone',
            deps: ['jquery', 'underscore']
        },
        'd3': {
            exports: 'd3'
        },
        'select2v4': ['jquery'],
        'bootstrap/modal': ['jquery'],
        'bootstrap/tooltip': ['jquery'],
        'backbone.queryparams': ['backbone'],
        'webfont': {
            exports: 'WebFont'
        },
        'jquery.sly': ['jquery'],
        'jquery.mobile': ['jquery'],
        'perfect-scrollbar.jquery': ['jquery']
    }
});
require(['modernizr',
        'moment',
        'underscore',
        'backbone',
        'closure-templates',
        'jquery',
        'FeatureConfig',
        'com/epam/heroes/core/core',
        'com/epam/heroes/core/config',
        'com/epam/heroes/core/util/GA',
        'com/epam/heroes/core/util/HeroesCookies',
        'com/epam/heroes/core/browserValidator',
        'com/epam/heroes/portal/core/router/AnyMatchRouter',
        'com/epam/heroes/portal/wall/router/WallRouter',
        'com/epam/heroes/portal/voting/router/VotingRouter',
        'com/epam/heroes/widget/givebadge/router/GiveBadgeRouter',
        'com/epam/heroes/portal/profile/opportunities/router/ProfileOpportunitiesRouter',
        'com/epam/heroes/portal/profile/mypoints/router/ProfileMyPointsRouter',
        'com/epam/heroes/portal/profile/history/router/ProfileHistoryRouter',
        'com/epam/heroes/portal/profile/portfolio/router/ProfilePortfolioRouter',
        'com/epam/heroes/portal/profile/portfolio/router/PortfolioLevelsRouter',
        'com/epam/heroes/portal/profile/portfolio/router/PortfolioCollectionsRouter',
        'com/epam/heroes/portal/profile/reviews/router/ProfileReviewsRouter',
        'com/epam/heroes/portal/profile/pending/router/ProfilePendingRouter',
        'com/epam/heroes/portal/profile/approved/router/ApprovedBadgesRouter',
        'com/epam/heroes/portal/search/router/SearchRouter',
        'com/epam/heroes/portal/review/rating/router/RatingRouter',
        'com/epam/heroes/portal/review/rating/beer/router/PageRouter',
        'com/epam/heroes/portal/review/vote/router/ActiveReviewRouter',
        'com/epam/heroes/portal/about/router/PageRouter',
        'com/epam/heroes/portal/core/router/V1RedirectRouter',
        'com/epam/heroes/core/view/BrowserAlertView',
        'com/epam/heroes/portal/dashboards/router/DashboardsRouter',
        'com/epam/closure/templates/functions',
        'backbone.queryparams',
        'jquery.sly',
        'bootstrap/tooltip'],
    function(modernizr,
             moment,
             _,
             Backbone,
             soy,
             $,
             featuresConfig,
             core,
             config,
             GA,
             HeroesCookies,
             BrowserValidator,
             AnyMatchRouter,
             WallRouter,
             VotingRouter,
             GiveBadgeRouter,
             ProfileOpportunitiesRouter,
             ProfileMyPointsRouter,
             ProfileHistoryRouter,
             ProfilePortfolio,
             PortfolioLevelsRouter,
             PortfolioCollectionsRouter,
             ProfileReviewsRouter,
             ProfilePendingRouter,
             ApprovedBadgesRouter,
             SearchRouter,
             RatingRouter,
             BeerRatingRouter,
             ActiveReviewRouter,
             AboutRouter,
             V1RedirectRouter,
             BrowserAlertView,
             DashboardsRouter
             ) {


        addFavicons = (img) => {
            const head = document.querySelector('head');
            img.map((href) => {
                const favicon = document.createElement('link');
                favicon.setAttribute('rel', href.indexOf('.ico') !== -1 ? 'shortcut icon' : 'icon' );
                href.indexOf('.ico') !== -1 &&
                favicon.setAttribute('id', 'favicon');
                href.indexOf('.png') !== -1
                && favicon.setAttribute('sizes', href.indexOf('16') !== -1 ? '16x16' : '32x32');
                head.appendChild(favicon);

                href.indexOf('.png') !== -1
                    ? favicon.setAttribute('type', 'image/png')
                    : favicon.setAttribute('type', 'image/x-icon');
                favicon.setAttribute('href', href);
            });
        };

        const VERSION = new Date().getTime();

        if (featuresConfig.featurePetrofacUiStylesEnabled) {
            require('../sass/petrofac-portal/main.scss');

            addFavicons([
                config.staticSiteUrl + `/images/portal/favicons/petrofac_favicon.ico?v=${VERSION}`,
                config.staticSiteUrl + `/images/portal/favicons/petrofac_favicon16.png?v=${VERSION}`,
                config.staticSiteUrl + `/images/portal/favicons/petrofac_favicon32.png?v=${VERSION}`
            ]);
        } else {
            addFavicons([
                config.staticSiteUrl + `/images/portal/favicons/favicon.ico?v=${VERSION}`,
                config.staticSiteUrl + `/images/portal/favicons/favicon16.png?v=${VERSION}`,
                config.staticSiteUrl + `/images/portal/favicons/favicon32.png?v=${VERSION}`
            ]);
        }

        /**
         * Test browser for preserve-3d support.
         */
        Modernizr.addTest('preserve3d', function() {
            var prop = Modernizr.testAllProps('transformStyle', 'pfx');
            var elem = document.createElement('a');
            elem.style[prop] = 'preserve-3d';
            var test = elem.style[prop] === 'preserve-3d';
            elem = null;
            return test;
        });

        // Change language to English globally
        moment.locale('en', {
            calendar: {
                sameDay: '[Today,] H:mm',
                lastDay: '[Yesterday,] H:mm',
                nextDay: '[Tomorrow,] H:mm',
                lastWeek: 'D MMM, H:mm',
                nextWeek: 'D MMM, H:mm',
                sameElse: 'D MMM YY, H:mm'
            },
            relativeTime: {
                future: '%s left',
                past: '%s ago',
                s: 'Seconds',
                m: 'A minute',
                mm: '%d minutes',
                h: 'An hour',
                hh: '%d hours',
                d: 'A day',
                dd: '%d days',
                M: 'A month',
                MM: '%d months',
                y: 'A year',
                yy: '%d years'
            }
        });

        /*
         * Set up custom headers that will be sent with all ajax requests.
         * Generate pseudorandom value (fkey) that will be sent
         * both as cookie and HTTP header in order to prevent CSRF attacks.
         */
        $.ajaxPrefilter(function(options, originalOptions, xhr) {
            var url = document.URL,
                step = null;
            if (/^.*\/vote\/\d+\/\d+$/.test(url)) {
                step = 'vote';
            } else if (/^.*\/rating\/\d+\/\d+$/.test(url)) {
                step = 'rating';
            }
            xhr.setRequestHeader('Heroes-API-Client', 'portal');
            if (step) {
                xhr.setRequestHeader('Heroes-API-Client-Step', step);
            }
            if (options.type !== 'GET') {
                var fkey = HeroesCookies.get('fkey');
                xhr.setRequestHeader('Heroes-API-Client-Fkey', fkey);
            }
        });
        var fkey = core.Application.uuid();
        HeroesCookies.set('fkey', fkey, {path: '/'});

        core.Application.setUser(new core.UserModel());

        //Check browser
        if (BrowserValidator.isOldBrowserVersion()) {
            var browserAlertView = new BrowserAlertView({
                name: 'BrowserAlertView',
                el: 'body',
                browsers: BrowserValidator.browsers
            });
            core.Application.setView(browserAlertView);
            browserAlertView.render();
        } else {
            // Create routers before history start
            new AnyMatchRouter(); // Make sure that AnyMatchRouter is the first one to be initialized
            new ProfilePortfolio();
            new PortfolioLevelsRouter();
            new PortfolioCollectionsRouter();
            new ProfileOpportunitiesRouter();
            new ProfileMyPointsRouter();
            new ProfileHistoryRouter();
            new ProfileReviewsRouter();
            new ProfilePendingRouter();
            new ApprovedBadgesRouter();
            new WallRouter();
            new VotingRouter();
            new GiveBadgeRouter();
            new SearchRouter();
            new RatingRouter();
            new BeerRatingRouter();
            new ActiveReviewRouter();
            if (featuresConfig.featureAboutUsEnabled && featuresConfig.featureHelpEnabled) {
                new AboutRouter();
            }
            new V1RedirectRouter();
            new DashboardsRouter();
        }

        Backbone.history.start({
            pushState: true,
            root: config.portalUrl
        });

        if (!featuresConfig.featurePetrofacUiStylesEnabled) {
            GA && GA.create(); // Create Google Analytics tracker
        }
    
});



// WEBPACK FOOTER //
// ./src/main/resources/static-site/js/portal-main.js